import { schema } from 'normalizr'

const user = new schema.Entity('users')

export default user
